<template>
  <LabeledTextInput
    name="phoneNumber"
    :placeholder="placeholder"
    :disabled="disabled"
    :mandatory="mandatory"
    :validation="validation"
    :formatter="withCountryCode ? msisdnFormatted : formatPhone"
    :width="width"
    :invalid.sync="invalid_"
    :model.sync="model_"
    ref="nestedInput"
  >
    <template v-for="slot in possibleChildSlotsFor('Phone')" v-slot:[`${slot.child}`]>
      <slot :name="`${slot.parent}`"></slot>
    </template>
    <template v-for="slotError in possibleChildSlotsFor('Error')" v-slot:[`${slotError.child}`]><slot :name="`${slotError.parent}`"></slot></template>
  </LabeledTextInput>
</template>
<script>

import syncProperty from '@/mixins/syncProperty'
import LabeledTextInput from '@/components/forms/LabeledTextInput.vue'
import { isValidPhoneExt, isValidPhoneExtIfNotEmpty, phoneNoExpExt } from '@/mixins/validators/phone'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'LabeledPhoneNumberInput',
  components: { LabeledTextInput },
  mixins: [
    syncProperty('model', 'model_'),
    syncProperty('invalid', 'invalid_')
  ],
  data () {
    return {
      knownNDCs: [
        '1501',
        '1502',
        '1505',
        '1508',
        '1510',
        '1511',
        '1512',
        '1513',
        '1514',
        '1515',
        '1516',
        '1517',
        '1518',
        '1519',
        '1520',
        '1521',
        '1522',
        '1523',
        '1525',
        '1526',
        '1531',
        '1551',
        '1555',
        '1556',
        '1563',
        '1566',
        '1567',
        '1570',
        '1573',
        '1575',
        '1576',
        '1577',
        '1578',
        '1579',
        '1588',
        '1590',
        '155',
        '160',
        '162',
        '163',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
        '178',
        '179'
      ]
    }
  },
  props: {
    model: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    withCountryCode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    validation: function () {
      if (this.mandatory) {
        return {
          required,
          isValidPhoneExt
        }
      }
      return {
        isValidPhoneExtIfNotEmpty
      }
    }
  },
  methods: {
    vflowForceFeedback () {
      this.$refs.nestedInput.vflowForceFeedback()
    },
    msisdnFormatted (v) {
      let p = v.replace(/([^0-9+-])/g, '').trim()
      if (p !== '') {
        if (!isValidPhoneExt(p)) {
          // check if number starts with country code with missing 00 or +
          if (p.substring(0, 2) === '49') {
            p = '+' + p
          }
          // check if user entered a MSISDN starting without zero and country code, i.e. 17323456
          // check if input starts with a known ndc
          for (let n = 0; n < this.knownNDCs.length; n++) {
            if (p.substring(0, this.knownNDCs[n].length) === this.knownNDCs[n]) {
              p = '+49' + p
              break
            }
          }
        }

        if (isValidPhoneExt(p)) {
          const partCountryCode = p.replace(phoneNoExpExt, '$2')
          const partPrefix = p.replace(phoneNoExpExt, '$5')
          const partNo = p.replace(phoneNoExpExt, '$6')
          let formatted = (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()

          // ensure we have a country code prefix
          if (formatted.substring(0, 1) !== '+') {
            // replace a double zero
            if (formatted.substring(0, 2) === '00') {
              formatted = '+' + formatted.substring(2)
            } else if (formatted.substring(0, 1) === '0') {
              formatted = '+49' + formatted.substring(1)
            } else if (formatted.substring(0, 1) === '1') {
              formatted = '+49' + formatted
            }
          }

          p = formatted
        }
      } else {
        p = ''
      }

      return p
    },
    formatPhone (v) {
      v = v.replace(/([^0-9+-])/g, '').trim()
      if (isValidPhoneExt(v)) {
        const partCountryCode = v.replace(phoneNoExpExt, '$2')
        const partPrefix = v.replace(phoneNoExpExt, '$5')
        const partNo = v.replace(phoneNoExpExt, '$6')
        return (partCountryCode + (partCountryCode !== '0' ? ' ' : '') + partPrefix + ' ' + partNo).trim()
      }
      return v
    }
  }
}
</script>
